<script>
import { filterObjectId } from "@/utils/helper"
import pick from "lodash/pick"
export default {
  name: "TableCrudMixin",
  mixins: [],
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "common.add" : "common.edit"
    },
  },

  data: function () {
    return {
      dialog: false,
      editedIndex: -1,
    }
  },
  methods: {
    editItem(item) {
      this.editedIndex = this.list.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    close() {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    closeDelete() {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },
    submit(fields, filter) {
      this.loading = true
      let func = this.ADD
      let edit = false

      if (this.editedIndex > -1) {
        func = this.UPDATE
        edit = true
      }

      func(pick(filterObjectId(this.editedItem, filter), fields))
        .then(async () => {
          await this.$toast.success(
            this.$t("common.success_" + (edit ? "edit" : "add"))
          )
          this.close()
        })
        .finally(() => {
          this.loading = false
        })
    },
    debounceFetchApi() {},
  },
  watch: {
    dialog(val) {
      val || this.close()
    },
    dialogDelete(val) {
      val || this.closeDelete()
    },
  },
}
</script>
